export const ModeratorModeBanner = () => {

    return (
        <div className='moderator-mode-banner'>
            <p>Moderator Mode Enabled</p>
        </div>
    );
};